import React, { useState, useEffect, useCallback, useMemo } from "react";
import TeacherHeader from "../common/TeacherHeader";
import Footer from "../common/Footer";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { baseUrl } from "../../Utility/constants";
import { getSchoolId, fetchSubjectGroupMaster } from "../../Utility/commonFunctions";

const MarkSFeedingPage = () => {
  const [schoolId, setSchoolId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const [standards, setStandards] = useState([]);
  const [sections, setSections] = useState([]);
  const [streams, setStreams] = useState([]);
  const [subjectGroups, setSubjectGroups] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [examTypes, setExamTypes] = useState([]);
  const [students, setStudents] = useState([]);
  const [isMarkFeeded, setIsMarkFeeded] = useState(false);

  const [selected, setSelected] = useState({
    standardId: "",
    sectionId: "",
    streamId: "",
    subjectGroupId: "",
    subjectId: "",
    examType: "",
    examMarkType: "",
  });

  // ✅ Load initial data
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [id, groupData, streamRes] = await Promise.all([
          getSchoolId(),
          fetchSubjectGroupMaster(),
          axios.get(`${baseUrl}/api/StreamMaster`),
        ]);
        setSchoolId(id);
        setSubjectGroups(groupData);
        setStreams(streamRes.data);
      } catch (err) {
        console.error("Initial data load failed", err);
      }
    };
    loadInitialData();
  }, []);

  // ✅ Fetch Standards
  useEffect(() => {
    if (!schoolId) return;
    axios
      .get(`${baseUrl}/api/StandardMaster/GetStandardBySchool?id=${schoolId}`)
      .then((res) => setStandards(res.data))
      .catch(() => setStandards([]));
  }, [schoolId, refreshKey]);

  // ✅ Fetch Sections
  useEffect(() => {
    if (!selected.standardId) {
      setSections([]);
      return;
    }
    axios
      .get(`${baseUrl}/api/SectionMaster/GetSectionByStandardID?id=${selected.standardId}`)
      .then((res) => setSections(res.data))
      .catch(() => setSections([]));
  }, [selected.standardId]);

  // ✅ Fetch Subjects
  const fetchSubjects = useCallback(async () => {
    const { standardId, streamId, subjectGroupId } = selected;
    if (!standardId || !streamId || !subjectGroupId) {
      setSubjects([]);
      return;
    }
    try {
      const res = await axios.get(`${baseUrl}/api/SubjectMaster/GetSubjectMasterByClassAndStream`, {
        params: {
          classId: standardId,
          streamId,
          subjectGroup: subjectGroupId,
          teacherId: localStorage.getItem("userID"),
          userType: localStorage.getItem("Role"),
        },
      });
      setSubjects(res.data);
    } catch (err) {
      if (err.response?.status === 404) setSubjects([]);
      else console.error("Error fetching subjects:", err);
    }
  }, [selected.standardId, selected.streamId, selected.subjectGroupId]);

  useEffect(() => {
    fetchSubjects();
  }, [fetchSubjects]);

  // ✅ Fetch Exam Types
  useEffect(() => {
    if (!selected.subjectId) {
      setExamTypes([]);
      setStudents([]);
      return;
    }
    axios
      .get(`${baseUrl}/api/CommonMaster/GetExamTypes`, { params: { subjectId: selected.subjectId } })
      .then((res) => setExamTypes(res.data))
      .catch(() => {
        setExamTypes([]);
        setStudents([]);
      });
  }, [selected.subjectId]);

  // ✅ Fetch Students with Final Marks merge
  // const fetchStudents = useCallback(async () => {
  //   setStudents([]);
  //   const { standardId, sectionId, streamId, subjectGroupId, subjectId, examType } = selected;

  //   if (!standardId || !sectionId || !streamId || !subjectGroupId || !subjectId || !examType) return;

  //   try {
  //     const { data } = await axios.get(
  //       `${baseUrl}/api/MarksFeeding/StudentDetailsByStandardIdAndSectionId`,
  //       { params: { StandardId: standardId, SectionId: sectionId, streamId, subjectGroup: subjectGroupId, subjectId, examType } }
  //     );

  //     if (!data || data.length === 0) {
  //       setStudents([]);
  //       setIsMarkFeeded(false);
  //       return;
  //     }

  //     const isMarked = data.some((stu) => stu.markStatus === "Marked");
  //     setIsMarkFeeded(isMarked);

  //     if (examType === "Final") {
  //       const merged = Object.values(
  //         data.reduce((acc, stu) => {
  //           const id = stu.studentId;
  //           if (!acc[id]) acc[id] = { ...stu, finalMarks: {}, marksFeedingIds: {}, examMaxMarks: {} };

  //           if (stu.examMarkType) {
  //             acc[id].finalMarks[stu.examMarkType] = { marks: stu.marksObtained ?? 0, marksFeedingId: stu.marksFeedingId ?? null };
  //             acc[id].marksFeedingIds[stu.examMarkType] = stu.marksFeedingId ?? null;
  //             acc[id].examMaxMarks[stu.examMarkType] = stu.maxMarks ?? 0;
  //           }

  //           acc[id].rollNo = stu.rollNo;
  //           acc[id].generalRegisterNo = stu.generalRegisterNo;
  //           acc[id].firstName = stu.firstName;
  //           acc[id].middleName = stu.middleName;
  //           acc[id].lastName = stu.lastName;

  //           return acc;
  //         }, {})
  //       );

  //       const finalStudents = merged.map((stu) => {
  //         const finalCategories = Object.keys(stu.finalMarks).map((k) => ({
  //           type: k,
  //           maxMarks: stu.examMaxMarks[k] ?? 0,
  //           marks: stu.finalMarks[k].marks ?? 0,
  //         }));

  //         finalCategories.forEach((cat) => {
  //           stu[`marksObtained_${cat.type}`] = cat.marks;
  //         });

  //         stu.examMaxMarks.finalCategories = finalCategories;

  //         return stu;
  //       });

  //       setStudents(finalStudents);
  //     } else setStudents(data);
  //   } catch (err) {
  //     console.error("Error fetching students:", err);
  //     setStudents([]);
  //     setIsMarkFeeded(false);
  //   }
  // }, [selected]);

  const fetchStudents = useCallback(async () => {
    setStudents([]);
    const { standardId, sectionId, streamId, subjectGroupId, subjectId, examType } = selected;

    if (!standardId || !sectionId || !streamId || !subjectGroupId || !subjectId || !examType) return;

    try {
      const { data } = await axios.get(
        `${baseUrl}/api/MarksFeeding/StudentDetailsByStandardIdAndSectionId`,
        {
          params: {
            StandardId: standardId,
            SectionId: sectionId,
            streamId,
            subjectGroup: subjectGroupId,
            subjectId,
            examType
          }
        }
      );

      if (!data || data.length === 0) {
        setStudents([]);
        setIsMarkFeeded(false);
        return;
      }

      // Marked check (case-insensitive safety)
      const isMarked = data.some((stu) => String(stu.markStatus).toLowerCase() === "marked");
      setIsMarkFeeded(isMarked);

      if (examType === "Final") {
        // Reduce response into students keyed by studentId
        const map = data.reduce((acc, row) => {
          const id = row.studentId;
          if (!acc[id]) {
            // Start a clean baseline object to avoid carrying over exam-specific fields from first row
            acc[id] = {
              studentId: id,
              schoolId: row.schoolId,
              firstName: row.firstName,
              middleName: row.middleName,
              lastName: row.lastName,
              rollNo: row.rollNo,
              generalRegisterNo: row.generalRegisterNo,
              examSeatNo: row.examSeatNo, 
              finalCategoriesMap: {},       // temporary map { type -> { marks, maxMarks, marksFeedingId } }
            };
          }

          // Only consider rows that have an examMarkType (Final components)
          if (row.examMarkType) {
            // normalize numbers (ensure numeric)
            const marksObtained = row.marksObtained == null ? 0 : Number(row.marksObtained);
            const maxMarks = row.maxMarks == null ? 0 : Number(row.maxMarks);
            const marksFeedingId = row.marksFeedingId == null ? null : row.marksFeedingId;

            acc[id].finalCategoriesMap[row.examMarkType] = {
              type: row.examMarkType,
              marks: Number.isFinite(marksObtained) ? marksObtained : 0,
              maxMarks: Number.isFinite(maxMarks) ? maxMarks : 0,
              marksFeedingId
            };
          }

          return acc;
        }, {});

        // Convert map -> array, and create marksObtained_<Type> fields and finalCategories array
        const finalStudents = Object.values(map).map((stu) => {
          const finalCategories = Object.values(stu.finalCategoriesMap || {});

          // Attach per-category numeric properties for easy bindings
          finalCategories.forEach((cat) => {
            // e.g., marksObtained_FinalTheory
            stu[`marksObtained_${cat.type}`] = cat.marks;
          });

          // One canonical place for UI to iterate: finalCategories (array of {type, marks, maxMarks, marksFeedingId})
          stu.finalCategories = finalCategories;

          // Remove temporary map to keep object tidy
          delete stu.finalCategoriesMap;

          return stu;
        })
        .sort((a, b) => (a.examSeatNo || 0) - (b.examSeatNo || 0));

        setStudents(finalStudents);
      } else {
        // Non-final exam - keep as-is (you might normalize numbers here if needed)
        // Normalize marksObtained & maxMarks to numbers for non-final as well
        const normalized = data.map((r) => ({
          ...r,
          marksObtained: r.marksObtained == null ? 0 : Number(r.marksObtained),
          maxMarks: r.maxMarks == null ? 0 : Number(r.maxMarks),
        }));
        setStudents(normalized);
      }
    } catch (err) {
      console.error("Error fetching students:", err);
      setStudents([]);
      setIsMarkFeeded(false);
    }
  }, [selected]);


  useEffect(() => { fetchStudents(); }, [fetchStudents]);

  // ✅ Handle Input Change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelected((prev) => ({ ...prev, [name]: value }));
    if (name === "subjectId") {
      setExamTypes([]);
      setStudents([]);
    }
    if (name === "examType" && value === "") setStudents([]);
  };

  // ✅ Handle Marks Input
  const handleMarkChange = (e, studentId) => {
    const { name, value } = e.target;
    setStudents((prev) =>
      prev.map((stu) => {
        if (stu.studentId !== studentId) return stu;
        
        let newVal = value;
        if (selected.examType !== "Final") {
          const max = stu.maxMarks; //?.[selected.examType?.toLowerCase()] ?? Infinity;
          if (Number(value) > max) { newVal = max; toast.warning(`Max allowed marks: ${max}`); }
        } else {
          const fieldType = name.replace("marksObtained_", "");
          const category = stu.finalCategories?.find((cat) => cat.type === fieldType);
          const max = category?.maxMarks ?? Infinity;
          if (Number(value) > max) { newVal = max; toast.warning(`Max allowed marks for ${fieldType}: ${max}`); }
        }

        return { ...stu, [name]: newVal };
      })
    );
  };

  // ✅ Submit Marks
const handleSubmit = async () => {
  if (!students.length) return toast.error("No students available for mark feeding.");

  const invalid = students.some((stu) => {
    if (selected.examType === "Final") {
      return stu.finalCategories.some((cat) => {
        const val = stu[`marksObtained_${cat.type}`];
        return (
          cat.maxMarks > 0 &&
          (val === undefined ||
            val === "" ||
            isNaN(val) ||
            Number(val) < -1 ||
            Number(val) > cat.maxMarks)
        );
      });
    } else {
      return (
        stu.marksObtained === undefined ||
        stu.marksObtained === "" ||
        isNaN(stu.marksObtained) ||
        Number(stu.marksObtained) < -1
      );
    }
  });

  if (invalid)
    return toast.error("Please enter valid marks (or -1 for absent students).");

  if (
    !window.confirm(
      "You want to submit the data. Once submitted, you cannot make changes."
    )
  )
    return;

  const select = document.getElementsByName("subjectGroupId")[0];
  if (select && selected.examType !== "Final" && select.value)
    selected.examMarkType = select.options[select.selectedIndex].text;

  const payload = students.flatMap((stu) => {
    const base = {
      StandardId: selected.standardId,
      SectionId: selected.sectionId,
      StreamId: selected.streamId,
      SubjectGroupId: selected.subjectGroupId,
      SubjectID: selected.subjectId,
      ExamType: selected.examType,
      TeacherId: localStorage.getItem("userID"),
      StudentId: stu.studentId,
      CreatedBy: localStorage.getItem("userID"),
      UpdatedBy: localStorage.getItem("userID"),
    };

    if (selected.examType === "Final") {
      return stu.finalCategories
        .filter(
          (cat) =>
            stu[`marksObtained_${cat.type}`] !== undefined &&
            stu[`marksObtained_${cat.type}`] !== ""
        )
        .map((cat) => ({
          ...base,
          ExamMarkType: cat.type,
          MarksObtained: Number(stu[`marksObtained_${cat.type}`]),
        }));
    }

    return [
      {
        ...base,
        ExamMarkType: selected.examMarkType,
        MarksObtained: Number(stu.marksObtained),
      },
    ];
  });

  try {
    const res = await axios.post(`${baseUrl}/api/MarksFeeding`, payload);
    if (res?.status === 200 && res.data.includes("successfully")) {
      toast.success(res.data);
      setRefreshKey((k) => k + 1);
      clearForm();
    }
  } catch {
    toast.error("Error submitting marks.");
  }
};


  // const handleSubmit = async () => {
  //   if (!students.length) return toast.error("No students available for mark feeding.");

  //   const invalid = students.some((stu) => {
  //     if (selected.examType === "Final") {
  //       return stu.examMaxMarks.finalCategories.some((cat) => {
  //         const val = stu[`marksObtained_${cat.type}`];
  //         return cat.maxMarks > 0 && (val === undefined || val === "" || isNaN(val) || Number(val) < -1 || Number(val) > cat.maxMarks);
  //       });
  //     } else {
  //       return stu.marksObtained === undefined || stu.marksObtained === "" || isNaN(stu.marksObtained) || Number(stu.marksObtained) < -1;
  //     }
  //   });

  //   if (invalid) return toast.error("Please enter valid marks (or -1 for absent students).");
  //   if (!window.confirm("You want to submit the data. Once submitted, you cannot make changes.")) return;

  //   const select = document.getElementsByName("subjectGroupId")[0];
  //   if (select && selected.examType !== "Final" && select.value)
  //     selected.examMarkType = select.options[select.selectedIndex].text;

  //   const payload = students.flatMap((stu) => {
  //     const base = {
  //       StandardId: selected.standardId,
  //       SectionId: selected.sectionId,
  //       StreamId: selected.streamId,
  //       SubjectGroupId: selected.subjectGroupId,
  //       SubjectID: selected.subjectId,
  //       ExamType: selected.examType,
  //       TeacherId: localStorage.getItem("userID"),
  //       StudentId: stu.studentId,
  //       CreatedBy: localStorage.getItem("userID"),
  //       UpdatedBy: localStorage.getItem("userID"),
  //     };

  //     if (selected.examType === "Final") {
  //       return stu.examMaxMarks.finalCategories
  //         .filter((cat) => stu[`marksObtained_${cat.type}`] !== undefined && stu[`marksObtained_${cat.type}`] !== "")
  //         .map((cat) => ({ ...base, ExamMarkType: cat.type, MarksObtained: Number(stu[`marksObtained_${cat.type}`]) }));
  //     }

  //     return [{ ...base, ExamMarkType: selected.examMarkType, MarksObtained: Number(stu.marksObtained) }];
  //   });

  //   try {
  //     const res = await axios.post(`${baseUrl}/api/MarksFeeding`, payload);
  //     if (res?.status === 200 && res.data.includes("successfully")) {
  //       toast.success(res.data);
  //       setRefreshKey((k) => k + 1);
  //       clearForm();
  //     }
  //   } catch {
  //     toast.error("Error submitting marks.");
  //   }
  // };

  const clearForm = () => {
    setSelected({ standardId: "", sectionId: "", streamId: "", subjectGroupId: "", subjectId: "", examType: "", examMarkType: "" });
    setExamTypes([]);
    setSections([]);
    setSubjects([]);
    setStudents([]);
    setIsMarkFeeded(false);
  };

  const dropdowns = useMemo(
    () => [
      { label: "Standard", name: "standardId", options: standards, labelKey: "standardName", valueKey: "id" },
      { label: "Section", name: "sectionId", options: sections, labelKey: "name", valueKey: "id" },
      { label: "Stream", name: "streamId", options: streams, labelKey: "name", valueKey: "id" },
      { label: "Group", name: "subjectGroupId", options: subjectGroups, labelKey: "subjectGroupName", valueKey: "subjectGroupId" },
      { label: "Subject", name: "subjectId", options: subjects, labelKey: "subjectName", valueKey: "subjectId" },
      { label: "Exam Type", name: "examType", options: examTypes, labelKey: "label", valueKey: "label" },
    ],
    [standards, sections, streams, subjectGroups, subjects, examTypes]
  );

  return (
    <>
      <TeacherHeader />
      <div className="container mt-5 mb-5">
        <div className="row g-3">
          {dropdowns.map(({ label, name, options, labelKey, valueKey }) => (
            <div className="col-md-3" key={name}>
              <label className="form-label">{label}</label>
              <select className="form-select" name={name} value={selected[name]} onChange={handleInputChange}>
                <option value="">Select {label}</option>
                {options.map((opt) => <option key={opt[valueKey]} value={opt[valueKey]}>{opt[labelKey]}</option>)}
              </select>
            </div>
          ))}
          {!isMarkFeeded && (
            <div className="col-md-3 d-flex align-items-end">
              <button className="btn btn-primary w-100 btn-sm" onClick={handleSubmit}>Submit Marks</button>
            </div>
          )}
        </div>

        <table className="table table-striped table-hover mt-3">
          <thead>
            <tr>
              <th>#</th>
              {/* <th>Roll No</th>
              <th>GR.No.</th> */}
              <th>Exam Seat No</th>
              <th>Name</th>              
              {/* {selected.examType === "Final"
                ? students[0]?.examMaxMarks?.finalCategories?.map((c) => <th key={c.type}>{c.type.replace("Final", "")}</th>)
                : <th>Obtained Marks (Use -1 for Absent students)</th>
              } */}
              {selected.examType === "Final"
                ? students[0]?.finalCategories?.map((c) => (
                  <th key={c.type}>{c.type.replace("Final", "")}</th>
                ))
                : <th>Obtained Marks (Use -1 for Absent students)</th>
              }
            </tr>
          </thead>
          <tbody>
            {students && students.map((stu, index) => (
              <tr key={stu.studentId}>
                <td>{index + 1}</td>
                {/* <td>{stu.rollNo}</td>
                <td>{stu.generalRegisterNo}</td> */}
                <td>{stu.examSeatNo}</td>
                <td>{`${stu.firstName} ${stu.middleName} ${stu.lastName}`}</td>                
                {selected.examType === "Final"
                  ? stu.finalCategories.map((c) => (
                    <td key={c.type}>
                      <input
                        type="number"
                        name={`marksObtained_${c.type}`}
                        value={stu[`marksObtained_${c.type}`] ?? ""}
                        onChange={(e) => handleMarkChange(e, stu.studentId)}
                        className="form-control"
                        max={c.maxMarks}
                        disabled={isMarkFeeded}
                        placeholder={c.type.replace("Final", "")}
                      />
                    </td>
                  ))
                  : <td>
                    <input
                      type="number"
                      name="marksObtained"
                      value={stu.marksObtained ?? ""}
                      onChange={(e) => handleMarkChange(e, stu.studentId)}
                      className="form-control"
                      disabled={isMarkFeeded}
                      max={40}
                    />
                  </td>
                }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default MarkSFeedingPage;
